import { useContext } from 'react';

import DocumentContext from '../contexts/DocumentContext.context';
import useEditorActive from './useEditorActive.hook';

/** A Dropdown's options; they live in a ref, read on every transaction so the list also follows an undo of the options alone. */
const useDropdownOptions = (fieldId: string | undefined): string[] | undefined => {
  const { templateDropdownOptionsRef } = useContext(DocumentContext);
  return useEditorActive(() => (fieldId ? templateDropdownOptionsRef.current[fieldId] : undefined));
};

export default useDropdownOptions;
